var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import '../../form/InputImage.js';
let EditNetworkForm = class EditNetworkForm extends LitElement {
    constructor() {
        super(...arguments);
        this.logoFile = null;
    }
    getNetworkTypeOptions() {
        if (!this.networkTypes) {
            return [this.network.network_type_id].map(typeId => ({
                value: typeId,
                label: typeId.toString(),
            }));
        }
        return this.networkTypes.map(type => ({
            value: type.network_type_id,
            label: type.name,
        }));
    }
    handleSubmit() {
        const detail = {
            network: this.network,
            logoFile: this.logoFile,
        };
        const event = new CustomEvent('submit-edit-network', {
            detail,
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleCancel() {
        const event = new CustomEvent('cancel-edit-network', {
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleNameChange(event) {
        this.network.name = event.detail;
    }
    handleDescriptionChange(event) {
        this.network.description = event.detail;
    }
    handleNetworkTypeChange(event) {
        this.network.network_type_id = event.detail.value;
    }
    handleLogoSelected(event) {
        const files = event.detail;
        this.logoFile = files.length > 0 && files[0] ? files[0] : null;
    }
    render() {
        return html `
      <div class="form-group">
        <label for="network-type">${msg('Network Type', { id: 'network.label.type', desc: 'Network type label' })}:</label>
        <select-input
          id="network-type"
          .options="${this.getNetworkTypeOptions()}"
          .value="${this.network.network_type_id}"
          .variant="primary"
          size="medium"
          @select-change="${this.handleNetworkTypeChange}"
        ></select-input>
        <label for="name">${msg('Name:', { id: 'network.edit.name', desc: 'Name label' })}</label>
        <input-text
          id="name"
          .value="${this.network?.name || ''}"
          size="large"
          variant="secondary"
          placeholder=${msg('Enter a name', { id: 'network.placeholder.enterName', desc: 'Name placeholder' })}
          @input-text="${this.handleNameChange}"
        ></input-text>
        <label for="description">${msg('Description (optional):', { id: 'network.edit.description', desc: 'Description optional label' })}</label>
        <input-text-area
          id="description"
          .value="${this.network?.description || ''}"
          size="medium"
          variant="secondary"
          placeholder=${msg('Enter a description', { id: 'network.placeholder.enterDescription', desc: 'Description placeholder' })}
          @input-text-area="${this.handleDescriptionChange}"
        ></input-text-area>
        <label for="logo">${msg('Logo (optional):', { id: 'network.edit.logo', desc: 'Logo optional label' })}</label>
        <input-image
          id="logo"
          @image-selected="${this.handleLogoSelected}"
        ></input-image>
      </div>
      <div class="buttons">
        <simple-button
          variant="secondary"
          @button-click="${this.handleCancel}"
          label=${CommonActions.cancel()}
        ></simple-button>
        <simple-button
          variant="primary"
          special
          @button-click="${this.handleSubmit}"
          label=${CommonActions.validate()}
        ></simple-button>
      </div>
    `;
    }
};
EditNetworkForm.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-family: inherit;
      color: black;
    }

    .form-group {
      display: flex;
      flex-direction: column;
    }

    label {
      margin-top: 5px;
      font-size: 14px;
      margin-bottom: 5px;
      color: black;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  `;
__decorate([
    property({ type: Object })
], EditNetworkForm.prototype, "network", void 0);
__decorate([
    property({ type: Object })
], EditNetworkForm.prototype, "networkTypes", void 0);
__decorate([
    state()
], EditNetworkForm.prototype, "logoFile", void 0);
EditNetworkForm = __decorate([
    localized(),
    customElement('edit-network-form')
], EditNetworkForm);
export { EditNetworkForm };
//# sourceMappingURL=EditNetworkForm.js.map